module.exports = "data:image/gif;base64,R0lGODlhEAAQAMQRAIo+ODZIbfTy9FBroc+ursbK0rq6uurb3aeyyLmPnKRpb93i7IGVus3V57B8eH19fQAAAP///wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACH5BAEAABEALAAAAAAQABAAAAVoYJSMiUJEKAqlkRMJCsCqrCAC57yyB6DMNJYDYDvoWATcy8XaRXoAx5CZcrIWwIgVJRjYjjPGgAHcRgaDAOthgBgeqcZgESikCpC8IYVmBAYsARBqXF4RBQFYKHh7KH4IAgF/a1mVLCEAOw=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu_icons/sortzalang.gif
// module id = 0i/R
// module chunks = 1